/**
 * Global z-index scale for layered UI components.
 * Uses consistent 100-point intervals to allow future additions between layers.
 * Modal backdrop and modal are intentionally paired (+1 offset).
 */
export const zIndex = {
  dropdown: 1000,
  banner: 1300,
  popover: 1400,
  modalBackdrop: 1499,
  modal: 1500,
  tooltip: 1600,
} as const;
